export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium mb-4">
              移动端体验
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              随时随地，追漫不停
            </h2>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载樱花动漫之家移动客户端，离线缓存、夜间模式、推送提醒，无论地铁通勤还是睡前时光，好漫画始终相伴。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-primary-600 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/15 text-white border border-white/25 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors">
                <i className="ri-android-fill text-lg"></i>
                Google Play
              </button>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-white/10 backdrop-blur-sm border border-white/15 flex items-center justify-center">
              <div className="text-center text-white/70">
                <i className="ri-smartphone-line text-5xl mb-2 block"></i>
                <span className="text-xs">扫码下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}